// extracted by mini-css-extract-plugin
export default {"bedsAndBaths":"BedsAndBaths_bedsAndBaths__YovMY"};